export const ICPMessage = () => {
  return (
    <footer className="pt-64">
      <p className="absolute left-0 bottom-0 w-full py-8 px-16 md:px-24 micro text-center bg-secondary">
        版权所有 © 2022 沃尔沃汽车销售（上海）有限公司（或其附属公司或许可方）{' '}
        <a href="https://beian.miit.gov.cn/#/Integrated/index" rel="noreferrer">
          沪ICP备13015731号-1
        </a>
      </p>
    </footer>
  );
};

export default ICPMessage;
